export const purposeOptions = [
  /*{ key: 'Preview', value: 'Preview', text: 'Preview' },*/
  { key: 'Editing', value: 'Editing', text: 'Editing' },
  { key: 'Release', value: 'Release', text: 'Release' },
  { key: 'Archive', value: 'Archive', text: 'Archive' },
];
